import { Component, Injector, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtymdService, templateUrlConfigUty } from './../_service_uty';
import { CrudbarNavComponent, MaterialModule } from 'jk-service';
//import { UtymdEditComponent,UtymdTabEditComponent } from './../_edit_uty';
import { UiModeType, PageKind } from 'jk-service';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
//import { JkAdvComponentModule } from '../../JkAdvComponent.module';
import { UtymdEditComponent } from '../utymd-edit/utymd-edit.component';



@Component({
  selector: 'app-utyji05-detail',
  standalone: true,
  imports: [
    MaterialModule,
    CrudbarNavComponent,
    JkaggridComponent,
  ],
  templateUrl: templateUrlConfigUty.utyji05_detail,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Utyji05DetailComponent extends jkSingleComponent implements OnInit {
  override _programId = 'utyji05-detail';
  constructor() {
    super();
    this.srv = new UtymdService();
    this.uiMode = UiModeType.dialog;  //dialog 'tab';
    this.pageKind = PageKind.detail;
    this.srv.programId = this.programId + '-detail'; // ### modi,不要亂改
    this.srv.linkMasterFields = 'MD001=MC001,MD002=MC002,MD011=MC020';
    this.masterEditPage = UtymdEditComponent;
    this.gridInitOpt = { programId: this.programId, sortField: 'MD003', sort: 'asc', defaultSort: null, pageKind: this.pageKind };

    this.constructorInit(); // ###

  }



}
